
import { mapGetters } from 'vuex'

export default {
  name: 'Images',
  head () {
    const i18nHead = this.$nuxtI18nHead({ addSeoAttributes: true })
    return {
      title: this.$i18n.t('seo.image.title'),
      htmlAttrs: {
        ...i18nHead.htmlAttrs
      },
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.$i18n.t('seo.image.description')
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content: this.$i18n.t('seo.image.keyWords')
        },
        {
          property: 'og:type',
          content: 'website'
        },
        {
          property: 'og:title',
          content: this.$i18n.t('seo.image.title')
        },
        {
          property: 'og:url',
          content: 'https://' + this.$i18n.localeProperties.domain + this.$route.fullPath
        },
        {
          property: 'og:description',
          content: this.$i18n.t('seo.image.description')
        },
        {
          property: 'twitter:card',
          content: 'summary'
        },
        {
          property: 'twitter:site',
          content: '@Enerdata'
        },
        {
          property: 'twitter:title',
          content: this.$i18n.t('seo.image.title')
        },
        {
          property: 'twitter:description',
          content: this.$i18n.t('seo.image.description')
        },
        ...i18nHead.meta
      ],
      link: [
        ...i18nHead.link
      ]
    }
  },
  computed: {
    ...mapGetters({
      pages: 'pages'
    }),
    pageLandscapeImage () {
      return require('../assets/images/jumbotron/homepage.jpg')
    },
    images () {
      const createImageFromPage = page => ({
        url: `/image/${page.seo.image}`,
        title: page.title,
        alt: page.title,
        href: `/${page.urlCategorie}${page.url}.html`
      })

      return this.pages
        .filter(page => page.seo?.image)
        .map(createImageFromPage)
    }
  }
}
